import csvtojson from "csvtojson";

export default class CSVManager {
	static ReadFile(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = () => {
				csvtojson().fromString(reader.result).then(jsonarray => {
					resolve(jsonarray);
				}).catch(err => {
					reject(err);
				});
			};
			reader.readAsText(file);
		});
	}

	static GenerateBatchCSV(predict) {
		let content = "Record ID,Score,Risk Level, Tentative Amount Qualified - LevelFi, Recommendation, First Name, Last Name, Applicant Email, Applicant Phone" + "\r\n";
		for (const row of predict) {

			content += row.recordIDs + "," + row.score + "," + row.risk_level + "," + row.ten_amount_levelfi + "," +  row.rec_levelfi + "," + row.first_name + "," + row.last_name + "," + row.email_address + "," +  row.applicant_phone + "\r\n";
		}
		return content;
	}

	static GenerateSingleCSV(fields, score, risklevel, ten_amount_levelfi) {
		const keys = Object.keys(fields).filter(key => {
			return key !== "Record ID" && fields[key] !== "";
		});
		let content = keys.join(",") + "\r\n";
		content += keys.map(key => fields[key]).join(",") + "\r\n";
		content += "\r\n";
		content += "LevelFi Score," + "LevelFi Risk Level," + "LevelFi Amount Qualified" + "\r\n";
		content += score + "," + risklevel + "," + ten_amount_levelfi + "," + "\r\n";
		return content;
	}
}



// WEBPACK FOOTER //
// ./src/services/csvmanager.js